const AlertMessages = {
    "user.import.rows.limit.exceeded": "A planilha excede o limite de 1.000 linhas.",
    'missing.cpf': 'O campo "CPF" é obrigatório.',
    "cpf.invalid": "O campo \"CPF\" é inválido.",
    "contact.is.already.the.main.one": "O contato selecionado já é o principal.",
    "invalid.hash": "Código inválido.",
    "password.confirm": "A senha e a confirmação devem ser idênticas.",
    "type.or.phone.is.empty": "É necessário informar o tipo e o número.",
    "incomplete.number": "É necessário informar o número completo",
    "number.already.exists": "Número de CELULAR já está sendo utilizado.",
    "email.not.validated": "E-mail não validado.",
    "invalid.password": "A senha não atende aos requisitos de segurança.",
    "invalid.newPassword": "A nova senha não atende aos requisitos de segurança.",
    "password.did.not.change": "Nova senha não pode ser igual a atual.",
    "currentPassword.does.not.match": "Senha atual inválida.",
    "missing.currentPassword": "O campo \"Senha atual\" é obrigatório.",
    "missing.newPassword": "O campo \"Nova senha\" é obrigatório.",
    "missing.confirmPassword": "O campo \"Confirmação de senha\" é obrigatório.",
    "cpf.already.in.use": "Este \"CPF\" já está sendo utilizado.",
    "login.already.exists": "Este \"Login\" já está sendo utilizado.",
    "missing.noCpfJustification": "É necessário informar uma justificativa para adicionar agente sem CPF.",
    "occurrence.groups.requires.permission": "Para utilizar um Grupo de Ocorrência, é necessária a permissão \"Ocorrências - Permitir a visibilidade somente do(s) grupo(s) de ocorrência\"",
    "contingent.requires.name.war": "Você não pode salvar agente com permissão de \"Atendimento e despacho - Contingente\" sem nome de guerra",
    "occurrences.my.groups.requires.group": "Você não pode salvar agente com permissão de \"Visibilidade somente meu grupo\" sem grupo de ocorrência selecionado",
    "cannot.remove.cpf": "Não é possível remover o CPF.",
    "cannot.change.system.user.login": "Não é possível alterar o login de um agente de sistema.",
    "cannot.change.system.user.name": "Não é possível alterar o nome de um agente de sistema.",
    "cannot.change.system.user.nameWar": "Não é possível alterar o nome de guerra de um agente de sistema.",
    "user.in.active.garrison.requires.name.war": "O usuário está em uma guarnição ativa. Não é possível remover o nome de guerra",
    "user.in.active.garrison.requires.contingent": "O usuário está em uma guarnição ativa. Não é possível remover permissão de \"Atendimento e despacho - Contingente\"",
    "user.leader.of.active.garrison.requires.garrison_leader": "O usuário é responsável por uma guarnição ativa. Não é possível remover permissão de \"Atendimento e despacho - Guarnições - Responsável\"",

    "cannot.share.email.without.sharing.info": "Ative a opção \"Compartilhar com outras corporações que utilizam o Sentry\" para compartilhar o Email.",
    "cannot.have.focal.point.without.sharing.info": "Ative a opção \"Compartilhar com outras corporações que utilizam o Sentry\" para compartilhar o ponto focal.",
    "invalid.shareDeviceId": "Dispositivo inválido.",
    "device.does.not.belong.to.user": "O dispositivo não pertence a este agente.",

    "new.user.cannot.have.devices": "Salve o agente antes de adicionar um dispositivo.",
    "device.already.exists": "Dispositivo já cadastrado em outro agente.",
    "device.already.added.to.user": "Dispositivo já cadastrado.",
    "device.does.not.exist": "Dispositivo inválido.",
    "device.sent.multiple.times": "Dispositivo enviado várias vezes.",
    "device.has.association": "O dispositivo está associado a uma regra ou a um monitoramento.",
    "device.has.associations": "O dispositivo está associado a uma regra ou a um monitoramento.",

    "cannot.inactivate.user.with.authorized.apps": "Agente possui dispositivos autorizados. Não é possível inativar.",
    "cannot.inactivate.user.with.material.caution": "Agente possui materiais em cautela. Não é possível inativar.",
    "cannot.inactivate.user.in.active.garrison": "Agente faz parte de uma guarnição ativa. Não é possível inativar.",
    "cannot.inactivate.user.leader.of.active.garrison": "Agente é responsável por uma guarnição ativa. Não é possível inativar.",

    "authorized.device.limit.reached": "Limite de licenças atingido.",

    "missing.name": "O campo \"Nome\" é obrigatório.",
    "missing.nameWar": "O campo \"Nome de guerra\" é obrigatório.",
    "missing.login": "O campo \"Login\" é obrigatório.",
    "missing.fantasyName": "O campo \"Nome fantasia\" é obrigatório.",
    "invalid.login": "O campo \"Login\" é inválido.",
    "invalid.cpf": "O campo \"CPF\" é inválido.",
    "invalid.email": "O campo \"E-mail\" é inválido.",
    "nameWar.already.exists": "Este \"Nome de Guerra\" já está sendo utilizado.",

    "invalid.delete": "Agente não pode ser excluído pois possui registros relacionados em outros cadastros.",

    "invalid.address_type": "O campo \"Tipo de endereço\" é inválido.",
    "sex.invalid": "O campo \"Sexo\" é inválido.",
    "educationLevel.invalid": "O campo \"Escolaridade\" é inválido.",
    "maritalStatus.invalid": "O campo \"Estado civil\" é inválido.",
    "userTeamId.invalid": "O campo \"Equipe\" é inválido.",
    "expeditionRg.invalid": "O campo \"RG data de expedição\" é inválido.",
    "emitterCnh.invalid": "O campo \"CNH data de emissão\" é inválido.",
    "expirationCnh.invalid": "O campo \"CNH data de vencimento\" é inválido.",
    "categoryCnh.invalid": "O campo \"CNH categoria\" é inválido.",
    "emitterWork.invalid": "O campo \"CTPS data de emissão\" é inválido.",
    "cellphoneNumber.invalid": "O campo \"Número celular\" é inválido.",
    "residentialNumber.invalid": "O campo \"Número residencial\" é inválido.",
    "dtBirth.invalid": "O campo \"Data de nascimento\" é inválido.",
    "residencial.already.exists": "Número RESIDENCIAL já está sendo utilizado.",
    "celular.already.exists": "Número CELULAR já está sendo utilizado",
    "duplicate.name": "Este \"Nome\" já está sendo utilizado.",
    "same.type.subtype.name": "Os nomes do tipo e subtipo não podem ser iguais",
    "duplicate.subtype.name": "Este \"Nome\" de subtipo já está sendo utilizado.",
    "subtype.name.required": "O campo \"Nome\" do subtipo é obrigatório.",
    "create.same.subtype": "Não é possível salvar 2 subtipos com o mesmo nome",
    "mandatory_subtype.requires.subtype": "O campo \"Nome\" do subtipo é obrigatório.",
    "units.required": "O campo \"Unidade de medida\" do subtipo é obrigatório.",
    "create.same.subtipe": "Não é possível salvar 2 subtipos com o mesmo nome",

    "missing.alternative.header.file": "O campo \"Logo do Cabeçalho\" é obrigatório.",
    "missing.exhibition.name": "O campo \"Nome de exibição\" é obrigatório.",
    "missing.address": "O campo \"Logradouro\" é obrigatório.",
    "missing.neighborhood": "O campo \"Bairro\" é obrigatório.",
    "missing.dispatch.help.terms" : "O campo \"Termo de responsabilidade (153 Cidadão)\" é obrigatório.",

    "fantasyName": "O campo \"Nome fantasia\" é obrigatório.",
    "socialName": "O campo \"Razão social\" é obrigatório.",
    "cnpj": "O campo \"CNPJ\" é obrigatório.",
    "material.alreadyRelated": "Fornecedor relacionado a uma aquisição não pode ser excluído.",

    "celular.sent.multiple.time": "Dispositivo enviado várias vezes.",
    "residentialNumber.sent.multiple.time": "Dispositivo enviado várias vezes.",

    "user.vms.bind.already.exists": "Agente já está vinculado.",

    "invalid.pin": "O campo \"PIN\" é inválido.",
    "missing.lanesToMigrate": "O campo número de câmeras é obrigatório.",
    "lanesToMigrate.invalid": "Número de câmeras incorreto.",
    "pin.invalid": "PIN incorreto.",
    "smart.has.lanes": "Smartcapture possui câmera(s) associada(s).",

    "alarm_system.account.already.exists": "Conta de monitoramento já cadastrada.",
    "alarm_system.account.cannot.change": "Não é possível alterar conta de monitoramento.",
    "alarm_system.account.limit.exceeded": "Limite de licenças atingido.",
    "alarm_system.ip.already.exists": "IP já cadastrado.",

    "cortex.cpf.invalid": "O usuário atual não possui CPF cadastrado.",
    "cortex.person.cpf": "Campo CPF não pode ser vazio.",
    "cortex.not.enabled": "Cortex desativado.",
    "cortex.token.expired": "Chave do cortex expirada.",
    "cortex.token.invalid": "Chave do cortex inválida.",
    "cortex.not.allow.renavam": "Usuário sem permissão de acesso ao  CÓRTEX - RENAVAM.",
    "cortex.not.allow.passages": "Usuário sem permissão de acesso ao CÓRTEX - PASSAGENS.",
    "cortex.not.allow.individual": "Usuário sem permissão de acesso ao CÓRTEX - INDIVÍDUOS.",

    "invalid.height": "O campo \"Altura (cm)\" é inválido.",

    'missing.rg.emitter': "O campo \"Emissor\" é obrigatório.",
    'rg.emitter.invalid': "O campo \"Emissor\" é inválido.",
    'date.birth.invalid': "O campo \"Data de nascimento\" é inválido.",

}

export default AlertMessages;